import { render, staticRenderFns } from "./upload_widget.vue?vue&type=template&id=82a97972&scoped=true&"
import script from "./upload_widget.vue?vue&type=script&lang=js&"
export * from "./upload_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a97972",
  null
  
)

export default component.exports